<template>
  <base-dialog @cancel="cancelDialog" :width="640">
    <div slot="header">选择优惠券</div>
    <div slot="body">
      <a-radio-group v-model="selectedId" class="coupon-list">
        <div
          v-for="item in coupons"
          :key="item.id"
          class="coupon-item"
          :class="{ active: selectedId === item.id }"
          @click="selectedId = item.id">
          <a-radio :value="item.id" class="coupon-radio" />
          <div class="coupon-main">
            <div class="coupon-amount">¥{{ formatAmount(item.amount) }}</div>
            <div class="coupon-meta">
              <div class="coupon-title">{{ item.notes || item.name || item.type || item.id }}</div>
              <div class="coupon-sub" v-if="item.valid_until">
                有效期至 {{ formatTime(item.valid_until) }}
              </div>
              <div class="coupon-sub" v-else-if="item.id">ID: {{ item.id }}</div>
            </div>
          </div>
        </div>
      </a-radio-group>
      <a-empty v-if="!coupons.length" description="暂无可用优惠券" />
    </div>
    <div slot="footer">
      <a-button @click="handleClear" v-if="params.selectedCouponId">不使用优惠券</a-button>
      <a-button type="primary" @click="handleConfirm" :disabled="!selectedId">确定</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'SelectCouponDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      selectedId: this.params.selectedCouponId || undefined,
      coupons: this.params.coupons || [],
    }
  },
  methods: {
    formatAmount (val) {
      const num = Number(val || 0)
      return Number.isNaN(num) ? '0.00' : num.toFixed(2)
    },
    formatTime (val) {
      if (!val) return ''
      return this.$moment ? this.$moment(val).format('YYYY-MM-DD HH:mm') : val
    },
    handleConfirm () {
      if (!this.selectedId) return
      const coupon = this.coupons.find(item => item.id === this.selectedId)
      if (this.params.onSelect) {
        this.params.onSelect(coupon)
      }
      this.cancelDialog()
    },
    handleClear () {
      if (this.params.onSelect) {
        this.params.onSelect(null)
      }
      this.cancelDialog()
    },
  },
}
</script>

<style lang="less" scoped>
.coupon-list {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
  max-height: 420px;
  overflow-y: auto;
}

.coupon-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover,
  &.active {
    border-color: #1890ff;
    background: #f0f7ff;
  }

  .coupon-radio {
    flex-shrink: 0;
  }

  .coupon-main {
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1;
    min-width: 0;
  }

  .coupon-amount {
    min-width: 88px;
    color: #ff4d4f;
    font-size: 20px;
    font-weight: 600;
  }

  .coupon-meta {
    min-width: 0;
  }

  .coupon-title {
    color: #000;
    font-size: 14px;
    font-weight: 500;
    word-break: break-all;
  }

  .coupon-sub {
    margin-top: 4px;
    color: #999;
    font-size: 12px;
  }
}
</style>
